import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { BoardCardRegistryService, BoardJSON } from "../lib";
import { BoardCardRendererComponent } from "./board-card-renderer.component";

@Component({
    selector: 'eas-board',
    templateUrl: './board.component.html',
    styleUrls: ['./board.component.css'],
    imports: [BoardCardRendererComponent],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardComponent {

    cardRegistry = inject(BoardCardRegistryService);

    boardJSON = input.required<BoardJSON>();
    board = computed(() => this.cardRegistry.boardFromJson(this.boardJSON()))
}